<template>
    <div class="saas-page message-command-page">
        <div class="saas-hero card-saas message-command-hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span class="px-1">/</span>
                    <router-link to="/message">{{ trans('message.message') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{ trans('message.draft') }}</span>
                </p>
                <h1 class="saas-hero__title">{{ trans('message.draft') }}</h1>
            </div>
        </div>
        <div class="card-saas card-saas--flush saas-message-layout message-command-layout">
            <div class="row g-0">
                <message-sidebar menu="draft" :statistics="statistics"></message-sidebar>
                <div class="col saas-message-main">
                    <h4 class="card-saas__title">{{ trans('message.draft') }}</h4>
                    <div class="saas-table-wrap" v-if="messages.total">
                        <table class="table admin-data-table mb-0">
                            <thead>
                                <tr>
                                    <th>{{ trans('message.recipient') }}</th>
                                    <th>{{ trans('message.subject') }}</th>
                                    <th></th>
                                    <th>{{ trans('message.drafted_at') }}</th>
                                    <th class="table-option">{{ trans('general.action') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="draft in messages.data" :key="draft.id">
                                    <td>
                                        <span class="message-row__person" v-if="draft.to_user_id">
                                            {{ draft.user_to.email }}
                                        </span>
                                    </td>
                                    <td><span class="message-row__subject" v-text="draft.subject"></span></td>
                                    <td><i class="fas fa-paperclip" v-if="draft.has_attachment"></i></td>
                                    <td><span class="message-row__date">{{ draft.updated_at | momentDateTime }}</span></td>
                                    <td class="table-option">
                                        <div class="btn-group">
                                            <router-link :to="`/message/${draft.uuid}/draft`" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" :aria-label="trans('general.edit')"><i class="fas fa-edit" aria-hidden="true"></i></router-link>
                                            <button class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" :key="draft.id" type="button" :aria-label="trans('message.delete_draft')" v-confirm="{ok: confirmDelete(draft)}" v-tooltip="trans('message.delete_draft')"><i class="fas fa-trash" aria-hidden="true"></i></button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="admin-list-table-card admin-empty-state message-empty-state" v-else role="status">
                        <div class="admin-empty-state__inner">
                            <div class="admin-empty-state__icon-wrap" aria-hidden="true">
                                <admin-icon name="pencil"></admin-icon>
                            </div>
                            <h4 class="admin-empty-state__title">{{ trans('general.no_result_found') }}</h4>
                        </div>
                    </div>
                    <pagination-record :page-length.sync="filterMessageForm.page_length" :records="messages" @updateRecords="getMessages" @change.native="getMessages"></pagination-record>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import messageSidebar from './message-sidebar'

    export default {
        components : { messageSidebar },
        data() {
            return {
                messages: {
                    total: 0,
                    data: []
                },
                filterMessageForm: {
                    page_length: helper.getConfig('page_length')
                },
                statistics: {
                    sent: 0,
                    inbox: 0,
                    draft: 0,
                    trash: 0
                }
            };
        },
        mounted(){
            if(!helper.hasPermission('access-message')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('message')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            this.getMessages();
            this.getStatistics();
        },
        methods: {
            getStatistics(){
                axios.post('/api/message/statistics')
                    .then(response => response.data)
                    .then(response => {
                        this.statistics.inbox = response.inbox;
                        this.statistics.sent = response.sent;
                        this.statistics.draft = response.draft;
                        this.statistics.trash = response.trash;
                    })
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            getMessages(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterMessageForm);
                axios.get('/api/message/draft?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.messages = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            confirmDelete(draft){
                return dialog => this.deleteDraft(draft);
            },
            deleteDraft(draft){
                axios.delete('/api/message/'+draft.uuid+'/draft')
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.statistics.draft -= 1;
                        this.getMessages();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            }
        },
        filters: {
          momentDateTime(date) {
            return helper.formatDateTime(date);
          }
        }
    }
</script>

<style scoped>
.message-row__person,
.message-row__subject {
    color: #0f172a;
    font-weight: 700;
}

.message-command-page {
    --linear-accent: #625cf6;
    --linear-line: #e5e7ef;
    --linear-muted: #687083;
}

.message-command-hero,
.message-command-layout {
    border-color: rgba(98, 92, 246, 0.14);
    background:
        radial-gradient(circle at top right, rgba(98, 92, 246, 0.12), transparent 28rem),
        rgba(255, 255, 255, 0.94);
}

.saas-message-main {
    background: #ffffff;
}

.saas-table-wrap {
    border-color: var(--linear-line);
    border-radius: 16px;
    box-shadow: 0 14px 38px rgba(31, 35, 48, 0.045);
}

.message-row__date {
    color: #64748b;
}

.message-empty-state {
    margin-top: 1rem;
}
</style>
